import type { SparklineYAxisProps } from '../types/sparkline-y-axis-props.js';

export const YAxis = (_: SparklineYAxisProps) => null;
